<div *ngIf="tipoModal==='nuevo'">
    <h2 class="titulo-card-amarillo" >Agregar miembro</h2> 
    <form [formGroup]="formCrear" autocomplete="on"  
        fxLayout="column wrap" fxLayoutAlign="center center" fxLayoutGap="10px"> 
        <mat-dialog-content>
        
            <table>   
                <tr>
                    <td><p class="table-row-title">RUT:</p></td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" class="input-rut"  formControlName="rut" id="rut" [errorStateMatcher]="stateRutValido">                             
                            <mat-error *ngIf="hasError('rut', 'required')">Rut es requerido</mat-error>
                            <p class="mat-error p-error" *ngIf="formCrear.hasError('rutValido')">Ingrese un RUT válido</p>            
                        </mat-form-field>
                    </td>
                    <td>
                        <button class="btn-buscar" (click)="buscar()" [disabled]="formCrear.hasError('rutValido') || formCrear.controls['rut'].value.length < 8">Buscar</button>
                    </td>
                </tr>        
                <tr>
                    <td><p class="table-row-title">Nombre:</p></td>
                    <td colspan="2">
                        <mat-form-field>
                            <input matInput type="text" formControlName="nombres" id="nombres" [disabled]="true">
                            <mat-error *ngIf="hasError('nombres', 'required')">Nombre es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Apellido:</p></td>
                    <td colspan="2">
                        <mat-form-field>
                            <input matInput type="text" formControlName="apellido" id="apellido" [disabled]="disabledCrear">
                            <mat-error *ngIf="hasError('apellido', 'required')">Apellido es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Correo electrónico:</p></td>
                    <td  colspan="2">
                        <mat-form-field>
                            <input matInput appMail type="text" formControlName="correoParticular" id="correoParticular" [disabled]="disabledCrear">
                            <mat-error *ngIf="hasError('correoParticular', 'required')">Correo electrónico es requerido</mat-error>
                            <mat-error *ngIf="hasError('correoParticular', 'pattern')">Ingrese un Correo electrónico válido</mat-error>
                             
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Teléfono:</p></td>
                    <td  colspan="2">
                        <mat-form-field>
                            <input matInput appNumeros type="text" formControlName="telefono" id="telefono" [disabled]="disabledCrear">
                            <mat-error *ngIf="hasError('telefono', 'required')">Telefono es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Cargo:</p></td>
                    <td  colspan="2">
                        <mat-form-field>
                            <mat-select  formControlName="idTablaMaestra" id="idTablaMaestra" name="idTablaMaestra">
                                <mat-option *ngFor="let op of opcionesEstamentos" [value]="op.idTablaMaestra">
                                    {{op.descripcionLarga}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasError('idTablaMaestra', 'required')">Estamento es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
            </table>  
        </mat-dialog-content>
        <mat-dialog-actions align="end">      
                <button mat-button mat-dialog-close class="mb-3 btn-cancelar">Cancelar</button>
                <button mat-button class="mb-3 btn-confirmar" (click)="guardarNuevoMiembro()" [disabled]="disabledCrear">Agregar</button>
        </mat-dialog-actions>
    </form>  
</div>

<div *ngIf="tipoModal==='editar'">
    <h2>Editar miembro</h2> 
    <div mat-dialog-content>
        <form [formGroup]="formEditar" autocomplete="on" novalidate 
        fxLayout="column wrap" fxLayoutAlign="center center" fxLayoutGap="10px"> 
            <table>   
                <tr>
                    <td><p class="table-row-title">RUT:</p></td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text"  class="input-rut"  formControlName="rut" id="rut" [(ngModel)]="dataMiembro.rut">
                            <mat-error *ngIf="hasErrorEditar('rut', 'required')">Rut es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>        
                <tr>
                    <td><p class="table-row-title">Nombre:</p></td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" formControlName="nombres" id="nombres" [(ngModel)]="dataMiembro.nombres" [disabled]="true">
                            <mat-error *ngIf="hasErrorEditar('nombres', 'required')">Nombre es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Apellido:</p></td>
                    <td>
                        <mat-form-field>
                            <input matInput type="text" formControlName="apellido" id="apellido" [(ngModel)]="dataMiembro.apellido" [disabled]="disabledCrear">
                            <mat-error *ngIf="hasErrorEditar('apellido', 'required')">Apellido es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Correo electrónico:</p></td>
                    <td>
                        <mat-form-field>
                            <input matInput appMail type="text" formControlName="correoParticular" id="correoParticular" [(ngModel)]="dataMiembro.correoParticular" [disabled]="disabledCrear">
                            <mat-error *ngIf="hasErrorEditar('correoParticular', 'required')">Correo electrónico es requerido</mat-error>
                            <mat-error *ngIf="hasErrorEditar('correoParticular', 'pattern')">Ingrese un Correo electrónico válido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Teléfono:</p></td>
                    <td>
                        <mat-form-field>
                            <input matInput appNumeros type="text" formControlName="telefono" id="telefono" [(ngModel)]="dataMiembro.telefono" [disabled]="disabledCrear">
                            <mat-error *ngIf="hasErrorEditar('telefono', 'required')">Telefono es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <td><p class="table-row-title">Estamento:</p></td>
                    <td>
                        <mat-form-field>
                            <mat-select [(ngModel)]="dataMiembro.estamento.idTablaMaestra" formControlName="idTablaMaestra" id="idTablaMaestra" name="idTablaMaestra">
                                <mat-option *ngFor="let op of opcionesEstamentos" [value]="op.idTablaMaestra">
                                    {{op.descripcionLarga}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="hasErrorEditar('idTablaMaestra', 'required')">Estamento es requerido</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
            </table>  
            <div mat-dialog-actions>        
                <button mat-button mat-dialog-close class="btn-cancelar">Cancelar</button>
                <button mat-button class="btn-confirmar" (click)="editarMiembro()" [disabled]="disabledEditar">Guardar</button>
            </div>
        </form> 
    </div>
</div>

<div *ngIf="tipoModal==='eliminar'">
    <h2>Borrar miembro</h2> 
    <div mat-dialog-content>
        ¿Está segura que desea <b>borrar</b> al miembro seleccionado?
    </div>
    <div mat-dialog-actions>
      <button mat-button class="btn-cancelar" mat-dialog-close>Cancelar</button>
      <button mat-button class="btn-confirmar" (click)="eliminarMiembro()">Borrar</button>
    </div>
</div>
 